const emailList = {
  support: 'support@agiledezign.com',
	upgrade: 'upgrade@agiledezign.com'
}

export default emailList
